var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 1.89941C3.78714 1.89941 1.16797 4.51858 1.16797 7.73275C1.16797 10.9469 3.78714 13.5661 7.0013 13.5661C10.2155 13.5661 12.8346 10.9469 12.8346 7.73275C12.8346 4.51858 10.2155 1.89941 7.0013 1.89941ZM9.78964 6.39108L6.48214 9.69858C6.40047 9.78025 6.28964 9.82691 6.17297 9.82691C6.0563 9.82691 5.94547 9.78025 5.8638 9.69858L4.21297 8.04775C4.0438 7.87858 4.0438 7.59858 4.21297 7.42941C4.38214 7.26025 4.66214 7.26025 4.8313 7.42941L6.17297 8.77108L9.1713 5.77275C9.34047 5.60358 9.62047 5.60358 9.78964 5.77275C9.9588 5.94191 9.9588 6.21608 9.78964 6.39108Z",
    fill: "#312F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.181c651399c6b9f79c9dc4cbb5e76de6.svg";
export { ForwardRef as ReactComponent };